// Freitragendes Schiebetor: aus Lichte → Torblatt, Gegengewicht, Rahmen, Felder, Fundamente
export const ST = { frameH: 96.4, omegaH: 62, railH: 96.4, railW: 50, vert: 70, vertIns: 9.5, railOver: 500, fieldMax: 2000, fill: 150, factor: 1.35 };
export const ST_MODELS = { LUNAR: { lamH: 40, gap: 20, lam: "Profil 40x20", deduct: 5 }, ASTRAL: { stabW: 40, gap: 90 } };
const ceil10 = (v) => Math.ceil(v / 10) * 10;

export function emptySchiebetor() {
  return { kunde: "", kommission: "", farbe: "RAL 7016 - Anthrazitgrau", model: "LUNAR", lichte: 4000, postHeight: 1330, bottom: 110, capGap: 20,
    infillOverride: null, side: "links", motor: true, foundLeftLen: null, foundLeftW: 600, foundDepth: 800, foundRight: 300, fangpfosten: "100x100x4", fuehrung: "100x100x4", abzug: 2 };
}

export function computeSchiebetor(p) {
  const L = Number(p.lichte) || 0, m = ST_MODELS[p.model] || ST_MODELS.LUNAR;
  const leafH = (Number(p.postHeight) || 0) - (Number(p.bottom) || 0) - (Number(p.capGap) || 0);
  const total = ceil10((L + ST.fill) * ST.factor);
  const infill = Number(p.infillOverride) || L + ST.fill;
  const frame = infill + 2 * ST.vert;
  const tail = total - frame;
  const nFields = Math.max(1, Math.ceil(infill / ST.fieldMax));
  const field = Math.round(((infill - (nFields - 1) * ST.vert) / nFields) * 10) / 10;
  const infillH = Math.round((leafH - ST.railH - ST.frameH - ST.omegaH) * 10) / 10;
  const vertL = Math.round((infillH + 2 * ST.vertIns) * 10) / 10;
  const diag = Math.round(Math.sqrt(tail * tail + infillH * infillH) * 100) / 100;
  const railL = frame + ST.railOver;
  const lamN = m.lamH ? Math.floor((infillH + m.gap) / (m.lamH + m.gap)) : 0;
  const stabN = m.stabW ? Math.floor((field + m.gap) / (m.stabW + m.gap)) : 0;
  const foundLeftLen = Number(p.foundLeftLen) || total - L;
  const fuehrungFromEdge = frame - L; // Führungssäule am Übergang Gegengewicht/Rahmen, gemessen ab Lichte-Kante
  const cut = [
    { name: "Omega-Laufschiene 70x62", n: 1, len: total },
    { name: "Rahmen unten 96,4", n: 1, len: total },
    { name: `Führungsschiene oben ${ST.railW}x${ST.railH}`, n: 1, len: railL },
    { name: "Vertikalprofil 70x45 (Rahmen + Sprossen)", n: nFields + 1, len: vertL },
    { name: "Diagonale (Gegengewicht)", n: 1, len: diag },
  ];
  if (lamN) cut.push({ name: `${m.lam} Lamellen (Feld − ${m.deduct} mm)`, n: lamN * nFields, len: Math.round((field - m.deduct - (Number(p.abzug) || 0)) * 10) / 10 });
  return { total, infill, frame, tail, nFields, field, leafH, infillH, vertL, diag, railL, lamN, stabN, foundLeftLen, fuehrungFromEdge, cut,
    posts: [{ name: `Führungssäule ${p.fuehrung}`, n: 1 }, { name: `Fangpfosten ${p.fangpfosten}`, n: 1 }, ...(p.motor ? [{ name: "Antrieb (neben Führungssäule)", n: 1 }] : [])] };
}
